<template>
  <div
    class="wrapper"
    :class="{'-visible': showHideable}"
  >
    <div class="max-width filter">
      <filter-categories :categories="categories" />
      <button @click="showHideable = !showHideable">
        {{ $t('components.vehicles_filters.refine_your_criteria') }}
      </button>
    </div>
    <div class="hideable">
      <div class="max-width">
        <filter-values
          :visible="showHideable"
          :filters="values"
        />
      </div>
    </div>
    <div class="max-width">
      <active-filters :active="active" />
    </div>
  </div>
</template>
<script>
import FilterCategories from './FilterCategories';
import FilterValues from './FilterValues';
import ActiveFilters from './ActiveFilters';

export default {
  components: {
    FilterCategories,
    FilterValues,
    ActiveFilters,
  },
  mounted() {
    this.activateFiltersFromUrl()
  },
  watch: {
    categories: {
      immediate: true,
      handler(val, oldVal) {
        if (!val || !val.length || oldVal.length) {
          return
        }
        this.activateFiltersFromUrl()
      },
    },
  },
  data() {
    return { showHideable: false };
  },
  computed: {
    categories() {
      return this.$store.state.vehicles.filters.categories;
    },
    values() {
      return this.$store.state.vehicles.filters.filters;
    },
    active() {
      return this.$store.getters['vehicles/filters/activeFilters'];
    },
  },
  methods: {
    activateFiltersFromUrl() {
      if (window.renaultRent && window.renaultRent.vehicleFilters) {
        this.$store.dispatch('vehicles/filters/ACTIVATE_CATEGORY_TYPE', window.renaultRent.vehicleFilters)
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../../../_src/sass/config/vars";
@import "../../../../../_src/sass/config/mixins";
@import "../../../../../_src/sass/config/responsive";

.wrapper {
  background: $c-alabaster;
  border-bottom: 1px solid $c-alto;
  margin: 30px 0 0;
  padding: 20px 0 0 0;
}

.max-width {
  margin: auto;
  max-width: calc(100% - 186px);
}

.filter {
  margin: 20px 20px;

  @include teq-breakpoint($medium) {
    margin: auto;
  }
}

button {
  align-items: center;
  background: $c-silver;
  border: none;
  cursor: pointer;
  display: flex;
  font-family: $f-graphie-book;
  height: 37px;
  justify-content: center;
  margin: 10px 0 0 0;
  outline: none;
  position: relative;
  width: 100%;

  @include font-size(14px);

  @include teq-breakpoint($medium) {
    margin: 10px 0 20px;
  }

  &::after {
    border: 0 solid transparent;
    border-bottom-color: $c-silver;
    bottom: -20px;
    content: "";
    height: 0;
    left: 50%;
    opacity: 0;
    position: absolute;
    transform: translateX(-50%);
    transition: border-width 300ms ease-out;
    width: 0;

    @include teq-breakpoint($medium) {
      opacity: 1;
    }

    .-visible & {
      border-width: 10px;
    }
  }
}

.hideable {
  background: white;
  border-bottom: 1px solid $c-silver;
  max-height: 0;
  overflow: hidden;
  padding: 0;
  transition: max-height 300ms ease-out, padding 300ms linear;

  @include teq-breakpoint($medium) {
    background: $c-silver;
    border-bottom: none;
  }

  .-visible & {
    max-height: 350px;
    //padding: 20px 0;
  }
}
</style>
